document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  const panel = drawer.querySelector(".cart-drawer__panel");
  let previousFocus = null;
  let isUpdating = false;

  const cartRoot = window.Shopify?.routes?.root || "/";

  window.themeCartDrawer = {
    async refreshAndOpen() {
      if (drawer.dataset.drawerEnabled === "false") { location.assign(cartRoot + "cart"); return; }
      await refreshCart();
      openCart();
    },
  };
  document.addEventListener('cart:updated', () => {
    window.themeCartDrawer.refreshAndOpen().catch((error) => {
      console.error('Cart drawer refresh failed:', error);
    });
  });

  /* ========================================================
     OPEN / CLOSE
  ======================================================== */

  function openCart() {
    previousFocus = document.activeElement;

    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    panel.setAttribute("aria-hidden", "false");

    document.body.style.overflow = "hidden";
    drawer.querySelector(".cart-drawer__close")?.focus();
  }

  function closeCart() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    panel.setAttribute("aria-hidden", "true");

    document.body.style.overflow = "";

    if (previousFocus instanceof HTMLElement) {
      previousFocus.focus();
    }
  }

  /* ========================================================
     RENDER UPDATED CART

     Shopify devuelve el HTML actualizado de la sección.
     Reemplazamos solamente el contenido del drawer.
  ======================================================== */

  async function refreshCart() {
    const sectionId = drawer.dataset.sectionId;

    if (!sectionId) {
      throw new Error("Cart drawer section ID not found");
    }

    const response = await fetch(
      `${cartRoot}?sections=${encodeURIComponent(sectionId)}`,
      { credentials: "same-origin" },
    );

    if (!response.ok) {
      throw new Error("Could not refresh cart");
    }

    const sections = await response.json();
    const html = sections[sectionId];

    if (!html) {
      throw new Error("Cart drawer section was not returned");
    }

    const doc = new DOMParser().parseFromString(html, "text/html");
    const updatedDrawer = doc.querySelector("[data-cart-drawer]");

    if (!updatedDrawer) {
      throw new Error("Updated drawer markup not found");
    }

    const updatedPanel = updatedDrawer.querySelector(".cart-drawer__panel");

    if (!updatedPanel) {
      throw new Error("Updated cart panel not found");
    }

    // Mantenemos el drawer abierto y reemplazamos
    // únicamente su contenido interno.
    panel.innerHTML = updatedPanel.innerHTML;

    // Actualizamos el contador del navbar.
    const cartResponse = await fetch(`${cartRoot}cart.js`, {
      credentials: "same-origin",
    });

    if (!cartResponse.ok) {
      throw new Error("Could not fetch cart count");
    }

    const cart = await cartResponse.json();

    document.querySelectorAll(".site-header__cart-count").forEach((count) => {
      count.textContent = cart.item_count;
    });
  }

  /* ========================================================
     UPDATE QUANTITY
  ======================================================== */

  async function updateCartItem(key, quantity) {
    if (isUpdating) return;

    isUpdating = true;
    drawer.classList.add("is-updating");

    try {
      const response = await fetch(`${cartRoot}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
          id: key,
          quantity,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || "Could not update cart");
      }

      await refreshCart();
      document.dispatchEvent(new CustomEvent('cart:summary-updated'));
    } catch (error) {
      console.error("Cart update failed:", error);
      alert(error.message || "Could not update cart");
    } finally {
      isUpdating = false;
      drawer.classList.remove("is-updating");
    }
  }

  /* ========================================================
     CLICK HANDLING

     Event delegation permite que los botones sigan
     funcionando después de reemplazar el HTML.
  ======================================================== */

  document.addEventListener("click", (event) => {
    const openButton = event.target.closest("[data-cart-open]");

    if (openButton) {
      if (drawer.dataset.drawerEnabled === "false") return;
      event.preventDefault();
      openCart();
      refreshCart().catch(error => console.error('Cart refresh failed:', error));
      return;
    }

    const closeButton = event.target.closest("[data-cart-close]");

    if (closeButton && drawer.contains(closeButton)) {
      closeCart();
      return;
    }

    const action = event.target.closest(
      "[data-cart-plus], [data-cart-minus], [data-cart-remove]",
    );

    if (!action || !drawer.contains(action)) return;

    const item = action.closest("[data-cart-item]");
    if (!item) return;

    const key = item.dataset.lineKey;
    const quantityElement = item.querySelector("[data-cart-quantity]");
    const currentQuantity = Number(quantityElement?.textContent || 0);

    let nextQuantity = currentQuantity;

    if (action.hasAttribute("data-cart-plus")) {
      nextQuantity++;
    }

    if (action.hasAttribute("data-cart-minus")) {
      nextQuantity = Math.max(0, currentQuantity - 1);
    }

    if (action.hasAttribute("data-cart-remove")) {
      nextQuantity = 0;
    }

    updateCartItem(key, nextQuantity);
  });

  /* ========================================================
     KEYBOARD ACCESSIBILITY
  ======================================================== */

  document.addEventListener("keydown", (event) => {
    if (!drawer.classList.contains("is-open")) return;

    if (event.key === "Escape") {
      closeCart();
      return;
    }

    if (event.key !== "Tab") return;

    const focusable = [
      ...panel.querySelectorAll(
        "a[href], button:not([disabled]), input:not([disabled])",
      ),
    ].filter((element) => element.getClientRects().length > 0);

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ========================================================
   PROMO CODE — TOGGLE
======================================================== */

  drawer.addEventListener("click", (event) => {
    const toggle = event.target.closest("[data-promo-toggle]");

    if (!toggle || !drawer.contains(toggle)) return;

    const content = drawer.querySelector("[data-promo-content]");
    if (!content) return;

    const willOpen = content.hidden;

    content.hidden = !willOpen;
    toggle.setAttribute("aria-expanded", String(willOpen));

    if (willOpen) {
      content.querySelector("[name='discount']")?.focus();
    }
  });

  /* ========================================================
   PROMO CODE — APPLY
======================================================== */

  drawer.addEventListener("submit", async (event) => {
    const form = event.target.closest("[data-promo-form]");

    if (!form || !drawer.contains(form)) return;

    event.preventDefault();

    if (isUpdating) return;

    const input = form.querySelector("[name='discount']");
    const button = form.querySelector("[type='submit']");
    const message = drawer.querySelector("[data-promo-message]");

    const code = input?.value.trim();

    if (!code || !message) return;

    const showMessage = (text, type = "") => {
      message.textContent = text;
      message.classList.remove("is-success", "is-error");

      if (type) {
        message.classList.add(`is-${type}`);
      }
    };

    isUpdating = true;
    button.disabled = true;
    drawer.classList.add("is-updating");

    showMessage("Applying promo code...");

    try {
      const response = await fetch(`${cartRoot}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
          discount: code,
        }),
      });

      const cart = await response.json();

      if (!response.ok) {
        throw new Error(cart.description || "Could not apply promo code.");
      }

      // Actualizamos los importes y el contenido con Shopify.
      await refreshCart();

      document.dispatchEvent(new CustomEvent('cart:summary-updated'));

      // refreshCart reemplaza el contenido interno del panel,
      // por eso buscamos nuevamente los elementos.
      const updatedContent = drawer.querySelector("[data-promo-content]");
      const updatedToggle = drawer.querySelector("[data-promo-toggle]");
      const updatedMessage = drawer.querySelector("[data-promo-message]");

      const applied = [...drawer.querySelectorAll('[data-applied-discount-code]')]
        .some(element => element.dataset.appliedDiscountCode.toLowerCase() === code.toLowerCase());
      const accepted = cart.discount_codes?.some(discount => discount.code.toLowerCase() === code.toLowerCase() && discount.applicable);
      const success = applied || accepted;
      if (updatedContent && updatedToggle) {
        updatedContent.hidden = !!success;
        updatedToggle.setAttribute("aria-expanded", String(!success));
        if (success) updatedToggle.focus();
        else updatedContent.querySelector("input")?.focus();
      }

      if (updatedMessage) {
        updatedMessage.textContent = applied
          ? "Discount applied. Your savings are shown above."
          : accepted
            ? "Code accepted. Any shipping discount will be calculated at checkout."
            : "This code did not apply a discount to the current cart. Check its conditions.";
        updatedMessage.classList.add(applied || accepted ? "is-success" : "is-error");
      }
    } catch (error) {
      console.error("Promo code error:", error);
      showMessage(error.message || "Could not apply promo code.", "error");
    } finally {
      isUpdating = false;
      drawer.classList.remove("is-updating");

      const currentButton = drawer.querySelector(
        "[data-promo-form] button[type='submit']",
      );

      if (currentButton) {
        currentButton.disabled = false;
      }
    }
  });
});
